import mustache from "mustache";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { _miles } from "../../../../../utils/numberUtils";
import template from "./capacidadFincaTemplate.html";

mustache.parse(template);

/** Tarjeta "Capacidad finca utilizada" del dashboard de Pesaje/Ganadería: %
 *  de ocupación (cabezas activas / capacidad estimada) con barra de progreso.
 *  Capacidad = `ganaderiaAnimalesXHectareaOptimo × hectareasProductivas`. */
export class CapacidadFincaCardRender implements IConnectRender {
  /**
   * @param _cabezasActivas Cabezas actualmente en la finca.
   * @param _capacidadTotal Capacidad estimada (animales).
   */
  constructor(
    private readonly _cabezasActivas: number,
    private readonly _capacidadTotal: number,
  ) {}

  render(): string {
    const porcentaje =
      this._capacidadTotal > 0
        ? Math.round((this._cabezasActivas / this._capacidadTotal) * 100)
        : 0;

    return mustache.render(template, {
      porcentaje,
      porcentajeAncho: Math.min(porcentaje, 100),
      capacidadTotal: _miles(Math.round(this._capacidadTotal)),
      descripcion: `${_miles(this._cabezasActivas)} animales activos / ${_miles(
        Math.round(this._capacidadTotal),
      )} capacidad`,
    });
  }

  connect(): void {}

  dispose(): void {}
}
